import { Configuration, LogLevel } from "@azure/msal-browser";

// IMPORTANT: Replace these placeholder values with your actual app registration details from Azure.
const MSAL_CLIENT_ID = "YOUR_CLIENT_ID_HERE"; // Application (client) ID
const MSAL_TENANT_ID = "YOUR_TENANT_ID_HERE"; // Directory (tenant) ID

/**
 * MSAL configuration for the application.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
    redirectUri: "http://localhost:3000"
  },
  cache: {
    cacheLocation: "sessionStorage", // This is more secure than localStorage
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message); // Uncomment for detailed logs
            return;
          case LogLevel.Verbose:
            // console.debug(message); // Uncomment for very detailed logs
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes we'd like to request.
 */
export const loginRequest = {
  scopes: ["User.Read"] // Basic scope to read user profile
};